import {Plugins, TypeImplementation} from '@packages/systems/wfdl';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {CollectionListSupportedProp} from '@packages/systems/dynamo/utils/CollectionListPropNameUtils';
import {CollectionListFilterRender} from '@packages/shared/render/plugins/Dynamo/CollectionListFilter/CollectionListFilterRender';
import {CollectionListCuratedRender} from '@packages/shared/render/plugins/Dynamo/CollectionListCurated/CollectionListCuratedRender';
import {CollectionListSortRender} from '@packages/shared/render/plugins/Dynamo/CollectionListSort/CollectionListSortRender';
import {
  getCollectionListFilterPropType,
  getCollectionListCuratedPropType,
  getCollectionListSortPropType,
} from '@packages/systems/dynamo/utils/CollectionListPropTypes';

const createFilterListType = (collectionId: string) => {
  return TypeImplementation.Unique({
    type: getCollectionListFilterPropType(),
    render: CollectionListFilterRender({collectionId}),
    icon: TypeImplementation.IconByName(
      qualify(Plugins.name('Dynamo'), typeName('Filter'))
    ),
    system: {
      displayName: 'Filters',
      bindUIVariant: 'custom',
      isLocalizable: true,
    },
  });
};

const createCuratedListType = (collectionId: string) => {
  return TypeImplementation.Unique({
    type: getCollectionListCuratedPropType(),
    render: CollectionListCuratedRender({collectionId}),
    icon: TypeImplementation.IconByName(
      qualify(Plugins.name('Dynamo'), iconName('Curated'))
    ),
    system: {
      displayName: 'Select items',
      bindUIVariant: 'custom',
      isLocalizable: true,
    },
  });
};

const createSortListType = (collectionId: string) => {
  return TypeImplementation.Unique({
    type: getCollectionListSortPropType(),
    render: CollectionListSortRender({collectionId}),
    icon: TypeImplementation.IconByName(
      qualify(Plugins.name('Dynamo'), iconName('Sort'))
    ),
    system: {
      displayName: 'Sort',
      bindUIVariant: 'custom',
      isLocalizable: true,
    },
  });
};

const COLLECTION_LIST_PROP_CREATORS: {
  readonly [K in CollectionListSupportedProp]: (
    collectionId: string
  ) => TypeImplementation.UniqueTypeImplementation;
} = {
  Filter: createFilterListType,
  Sort: createSortListType,
  Curated: createCuratedListType,
} as const;

export const createCollectionListType = (
  propType: CollectionListSupportedProp,
  collectionId: string
) => {
  const creator = COLLECTION_LIST_PROP_CREATORS[propType];
  if (!creator) {
    throw new Error(`No creator for collection list prop type ${propType}`);
  }
  return creator(collectionId);
};
